// VUE, PINIA, ROUTER, PLUGINS, VEE-VALIDATE, GTAG - START
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import mixinPlugins from '@/plugins/mixinPlugins.js'
import { createGtm } from '@gtm-support/vue-gtm';
import { useSentry } from './services/sentry'
import { getEnv } from '@/plugins/getEnv.js';
const ENV = getEnv();

import '@/plugins/veeValidate.config'

// import VueGtag from 'vue-gtag'

import './assets/main.css'
import App from './App.vue'
// VUE, PINIA, ROUTER, PLUGINS, VEE-VALIDATE, GTAG - END

// CREATE APP - START
const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

useSentry(app, router)
app.use(pinia)
app.use(router)
app.mixin(mixinPlugins)
// app.use(VueGtag, {
//   config: { id: 'G-Q3DPE5VKT7' }
// })

app.use(
  createGtm({
    id: 'GTM-W4RMHGS', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
    // queryParams: {
    //   // Add URL query string when loading gtm.js with GTM ID (required when using custom environments)
    //   gtm_auth: 'AB7cDEf3GHIjkl-MnOP8qr',
    //   gtm_preview: 'env-4',
    //   gtm_cookies_win: 'x',
    // },
    defer: false, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
    compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
    nonce: '2726c7f26c', // Will add `nonce` to the script tag
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    // debug: true, // Whether or not display console logs debugs (optional)
    // loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
    // ignoredViews: ['homepage'], // Don't trigger events for specified router names (optional)
    trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
  }),
);

// <!-- Meta Pixel Code -->
if (ENV === 'prod') {
  // Inject Facebook Pixel script
  !(function(f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function() {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = true;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

  fbq('init', '2755849031470223');
  fbq('track', 'PageView');
}
// <!-- Meta Pixel Code -->

app.mount('#app')
// CREATE APP - END
